import { render } from "./ReferalView.vue?vue&type=template&id=5337da7b&ts=true"
import script from "./ReferalView.vue?vue&type=script&lang=ts"
export * from "./ReferalView.vue?vue&type=script&lang=ts"

import "./ReferalView.vue?vue&type=style&index=0&id=5337da7b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__